export enum CalculationAmountTaxedType {
    FULL = 'full',
    PROFIT = 'profit',
}

export enum CalculationPayInType {
    REGULAR = 'regular',
    INCLUSIVE = 'inclusive',
}

export enum CalculationPayOutType {
    THRESHOLD = 'threshold',
    STAIRCASE = 'staircase',
}

export enum TaxSchemeIds {
    STS = 1,
    UGANDA = 2,
    KENIA = 3,
    CROATIA = 4,
    ZAMBIA = 5,
    MOZAMBIQUE = 6,
}
